export default __webpack_public_path__ + "static/pathwise_doc_4-55384edb445c23173689e6f281e2d3c2.gif";